$(() => {
  $('#accordionFaq').on('click', '.btn-link', function() {
    $(this).find('.icon').toggleClass('icon--rotate')
  })
})